import React, {useEffect, useState} from "react";
import {Card, Col, Divider, Image, Row, Spin, Table, Button, Grid} from "antd";
import {ButtonContainer} from "../../MaterialsDetail/style";
import {LeftOutlined} from "@ant-design/icons";
import {MyButton, MyText} from "../../../components";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate} from "react-router-dom";
import {fetchTestResultsAction, RootState, ROUTE_PATH, selectStore} from "../../../utils";
import {fetchScreeningEarlyTestsListAction} from "../../../utils/store/pages/screening";
import parse from 'html-react-parser';
import {RecommendationsContainer} from "./style";
import {useTranslation} from "react-i18next";
import Link from "antd/es/typography/Link";
import { StyledCard } from "./style";
import { ScreeningConsultationPopup } from "../../../components/popups/ScreeningConsultationsPopup";
import {Cookies} from "react-cookie";
import { COOKIE_KEY } from "../../../utils";
import { useEmbeddedNavigate, useEmbeddedLink } from "../../../utils/context/embed";

export const TestsListNeuroPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  const {t} = useTranslation("common")
  const [kindergartens, setKindergartens] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const {screening: {testsList: testsListState}}:RootState = useSelector(selectStore)
  const {screening: {testsEarlyList: testsEarlyListState}}:RootState = useSelector(selectStore)
  const testResults = useSelector((state: any) => state.materials?.testResults ?? { data: null, loading: false });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const isEmbed = urlParams.get('embed'); 
  const eToken = urlParams.get('etoken'); 
  const [isResultModalVisible, setResultIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleOk = () => setIsModalVisible(false);
  const handleCancel = () => setIsModalVisible(false);
  const embeddedLink = useEmbeddedLink();
  
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  // useEffect(() => {
  //   if (!testsEarlyListState.success) {
  //     dispatch(fetchScreeningEarlyTestsListAction({type: 3}))
  //   }
  // }, [testsEarlyListState.success]);
  const cookies = new Cookies()
  const isTablet = screens.md && !screens.xl && !screens.xxl;

  useEffect(() => {
    if (isEmbed && eToken) return;
  
    const token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
    if (!token) {
      embeddedNavigate("/auth");
    }
  }, [embeddedNavigate, isEmbed, eToken]);

  useEffect(() => {
      dispatch(fetchScreeningEarlyTestsListAction({type: 3}))
   
  }, []);

  const handleGoBack = () => {
    embeddedNavigate("/");
  }

  const handleSelectTest = (id:any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.SCREENING_CURRENT_NEURO, {testId: id})
    }

    embeddedNavigate(path)
  }

  const formatDate = (dateString: any) => {
    const [year, month, day] = dateString.split(' ')[0].split('-');
    return `${day}.${month}.${year}`;
  };

  const ageFormatted = (age: number) => {
    if (age < 12) {
      return `${age} ${t("months")}`;
    } else {
      const years = Math.floor(age / 12);
      return `${years} ${t("ages3")}`;
    }
  };

  const showResultModal = (item: any) => {
    setSelectedItem(item);
    embeddedNavigate(`/results/testId/${item.test_id}/type/3`);
    
  };

  // useEffect(() => {
  //       const fetchData = async () => {
  //         try {
  //           const response = await fetchTestResults(3);
  //           if (response && response.results) {
  //             setKindergartens(response.results);
  //           } else {
  //             setKindergartens([]);
  //           }
  //         } catch (error) {
  //           console.error("Ошибка при получении данных:", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       };
    
  //       fetchData();
  //     }, []);

  useEffect(() => {
    dispatch(fetchTestResultsAction({ type: 3 }));
  }, []);

  useEffect(() => {
    if (!testResults.success || !testResults.data?.results) return;
    setKindergartens(testResults.data.results);
    setLoading(false);
  }, [testResults.success, testResults.data]);
  
      const showModal = (item: any) => {
        setSelectedItem(item);
        setIsModalVisible(true);
      };
  

  const dataSource = kindergartens.map((item, index) => ({
    key: item.id,
    number: index + 1,
    name: item.name,
    testType: item.list.name,
    age: ageFormatted(item.age),
    recommendation: item.recommendation,
    scores:(
      <Row style={{background: 'rgba(244, 245, 247, 1)', borderRadius: 12, height: 52, width: 52, alignItems: 'center', justifyContent: 'center'}}>
        <MyText color='rgba(19, 15, 38, 1)' weight={700}>{item.score}</MyText>
      </Row>

    ),
    time: formatDate(item.time_at),
    director: item.director_fio,
    phones: (
      
      <Button>{item.phone}</Button>
    
    ),
    consultationPoint: (
      <Link to={embeddedLink(`/articles?type=speech_therapist/${item.id}`)}>
        
          <Button style={{borderRadius: 12, height: 48, background:'rgba(231, 250, 255, 1)', border: 'none'}} onClick={() => showResultModal(item)}><MyText color='rgba(0, 141, 210, 1)' weight={600}>{t("view")}</MyText></Button>
      </Link>
    ),
    consultationSpeciality: (
      <Link to={embeddedLink(`/articles?type=speech_therapist/${item.id}`)}>
        <MyButton color='orange' type='primary' onClick={() => showModal(item)}>{t("send")}</MyButton>
      </Link>
    ),
  }));

  const columns = [
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>№</span>,
      dataIndex: 'number',
      key: 'number',
      width: '5%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("testType")}</span>,
      dataIndex: 'testType',
      key: 'testType',
      width: '18%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("childName")}</span>,
      dataIndex: 'name',
      key: 'name',
      width: '18%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("age")}</span>,
      dataIndex: 'age',
      key: 'age',
      width: '20%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("testDate")}</span>,
      dataIndex: 'time',
      key: 'time',
      width: '15%',
    },
    // {
    //   title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("points")}</span>,
    //   dataIndex: 'scores',
    //   key: 'scores',
    //   width: '15%',
    // },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("result")}</span>,
      dataIndex: 'consultationPoint',
      key: 'consultationPoint',
      width: '15%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{t("specialistConsultation")}</span>,
      dataIndex: 'consultationSpeciality',
      key: 'consultationSpeciality',
      width: '15%',
    },
  ];

  return(
    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 26, height: '60px'}}>
        {screens.xs ? (
    <>
      <Col span={3}>
        <ButtonContainer onClick={handleGoBack}>
          <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
        </ButtonContainer>
      </Col>
      <Col span={21}>
        <MyText
          color="rgba(19, 15, 38, 1)"
          size={26}
          weight={800}
          style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
        >
          Нейропсихология
        </MyText>
      </Col>
    </>
  ) : (
    <>
      <ButtonContainer onClick={handleGoBack}>
        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
      </ButtonContainer>
      <MyText
        color="rgba(19, 15, 38, 1)"
        size={32}
        weight={800}
        style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
      >
        Нейропсихология
      </MyText>
    </>
  )}
        </Row>
        <Card>
          <Spin spinning={testsEarlyListState?.loading}>
            <Row gutter={[24, 24]}>
              {testsEarlyListState?.data &&
                testsEarlyListState?.data?.map((oneTest: any) => (
                  <Col
                    key={oneTest.id + "-game-category"}
                    span={24}
                  >
                    <Card
                      bordered
                      hoverable
                      onClick={() => {
                        // if (!oneTest.recommendations) {
                          handleSelectTest(oneTest.id);
                        // }
                      }}
                      styles={{
                        body: {
                          padding: 16
                        }
                      }}
                    >
                      <Row style={{marginBottom: 12}}>
                        <Col span={screens.xs || isTablet ? 24 : 3}>
                          <MyText size={18}>
                          {`${t("title")}`}:
                          </MyText>
                        </Col>
                        <Col>
                          <MyText weight={700} size={18}>{oneTest.name}</MyText>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={screens.xs || isTablet ? 24 : 3}>
                          <MyText size={18}>{`${t("description")}`}:</MyText>
                        </Col>
                        <Col>
                          <MyText size={18}>{oneTest.description}</MyText>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 12}}>
                        <Col span={screens.xs || isTablet ? 24 : 3}>
                          <MyText size={18}>{`${t("note")}`}:</MyText>
                        </Col>
                        <Col>
                          <MyText size={18}>{`${t("noteOneToSevenYears")}`}</MyText>
                        </Col>
                      </Row>
                      <Divider style={{marginTop: 16, marginBottom: 16}}/>
                      <Row style={{marginBottom: '20px'}}>
{/* 
                        {oneTest.recommendations ? (
                          <div style={{
                            padding: 12,
                            backgroundColor: "#d1f8e0",
                            border: "1px solid #1aee89",
                            borderRadius: 12
                          }}>
                            <MyText color="#1aee89" size={18}>
                              Пройден
                            </MyText>
                          </div>
                        ) : ( */}
                        <Col span={24} >
                        
                        
                          <Row>
                          {oneTest.recommendations ? (
                            // <div style={{
                            //   padding: 12,
                            //   backgroundColor: "#d1f8e0",
                            //   border: "1px solid #1aee89",
                            //   borderRadius: 12
                            // }}>
                            //   <MyText color="#1aee89" size={18}>
                            //   {`${t("passed")}`}
                            //   </MyText>
                            // </div>
                            <MyButton type="primary">
                            {`${t("takeTest")}`}
                            </MyButton>
                          ) : (
                            <Row justify="space-between" style={{width: "100%"}}>
                              <MyButton type="primary">
                              {`${t("takeTest")}`}
                              </MyButton>
                            {/* <div style={{
                              marginLeft: 12,
                              padding: 12,
                              backgroundColor: "#ffe1e1",
                              border: "1px solid #F32D2D",
                              borderRadius: 12
                            }}>
                              <MyText color="#F32D2D" size={18}>
                              {`${t("notPassed")}`}
                              </MyText>
                            </div> */}
                            </Row>
                          )}
                          </Row>
                          </Col>

                        {/* )} */}
                      </Row>

                      {/* {oneTest.recommendations && (
                        <>
                          <Card styles={{body: {padding: 12}}}>
                            <Row style={{flexDirection: "column"}}>
                              <MyText weight={700} size={18} style={{marginBottom: 18}}>Рекомендации</MyText>
                              <RecommendationsContainer>
                                {parse(oneTest.recommendations)}
                              </RecommendationsContainer>
                            </Row>
                          </Card>
                        </>
                      )} */}

                    </Card>
                  </Col>
                ))}
            </Row>
          </Spin>

          <Row justify='center' style={{marginTop:20}}>
          <Col span={24}>
            <Row gutter={[32, 32]}>
              <Col span={24}>
              {screens.xs || isTablet ? (
                kindergartens.map((item, index) => (

                  <StyledCard key={item.id} style={{ marginBottom: 12 }}>
                  <Col style={{marginTop: 16}}>
                    <MyText size={16} weight={800} style={{fontFamily: 'Nunito'}}>№ {index + 1}</MyText>
                  </Col>
                  <Col>
                    <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{t("testType")}: {item.list.name}</MyText>
                  </Col>
                  <Col>
                    <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{t("childName")}: {item.name}</MyText>
                  </Col>
                  <Col>
                    <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{t("age")}: {ageFormatted(item.age)}</MyText>
                  </Col>
                  <Col>
                    <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{t("testDate")}: {formatDate(item.time_at)}</MyText>
                  </Col>
                  <Divider style={{marginTop: 16, marginBottom: 12}}/>
                  <Col span={24}>
                    <Link to={embeddedLink(`/articles?type=speech_therapist/${item.id}`)}>
                      {/* <Button style={{ borderRadius: 12, height: 48, background: 'rgba(231, 250, 255, 1)', border: 'none' }} onClick={() => showResultModal(item)}> */}
                        <MyText color='rgba(0, 141, 210, 1)' weight={600} onClick={() => showResultModal(item)} style={{fontFamily: 'Nunito'}}>{t("view")}</MyText>
                      {/* </Button> */}
                    </Link>
                  </Col>
                  <Col span={24} style={{marginBottom: 12}}>
                    <Link to={embeddedLink(`/articles?type=speech_therapist/${item.id}`)}>
                      {/* <MyButton color='orange' type='primary' onClick={() => showModal(item)}>{t("send")}</MyButton> */}
                      <MyText color='rgb(255, 149, 0)' weight={600} onClick={() => showModal(item)} style={{fontFamily: 'Nunito'}}>{t("send")}</MyText>

                    </Link>
                  </Col>
                </StyledCard>
                ))
              ): (
                    <StyledCard>
                      <Table dataSource={dataSource} columns={columns} pagination={false} loading={loading} />
                    </StyledCard>
                    )}
                  </Col>
                </Row>
          </Col>
        </Row>
        </Card>
        <ScreeningConsultationPopup visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} selectedItem={selectedItem} />
        
      </Col>
    </Row>
  )
}